import Search from 'antd/lib/input/Search';
import React from 'react';
import { useDebouncedCallback } from 'use-debounce';
import useSearchParam from '../../hooks/useQueryParams';

import styles from './CustomSearch.module.scss';


interface Props {
  onChange?:Function
  queryParams: string;
  style?: string;
}

const CustomSearch = ({style, queryParams = 's'}:Props) => {
  const [search, setSearchQuery] = useSearchParam(queryParams)
  const debouncedSearch = useDebouncedCallback((search) => setSearchQuery(search), 400)

  return (
    <Search 
      className={`${style} ${styles.search}`} 
      onChange={e => debouncedSearch(e.target.value)}
      />
  )
}

export default CustomSearch;